import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DashboardButton } from '../Styled';
import { ErrorWrapper } from './components/Styled';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { children, message, fullPage } = this.props;
    if (!this.state.hasError) return children;

    return (
      <ErrorWrapper fullPage={fullPage}>
        <p>{message}</p>
        <DashboardButton onClick={() => window.location.reload()}>Reload page</DashboardButton>
      </ErrorWrapper>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string,
  fullPage: PropTypes.bool,
};

ErrorBoundary.defaultProps = {
  message: 'Something went wrong. Please reload the page.',
  fullPage: false,
};

export default ErrorBoundary;
